import axiosInstance from '../../../../../../services/axios/axios';
import { then } from '../../../../../../services/axios/_utility';
import { WrapImsPacket } from '../../../../../../store/utility';

/**
 * Asynchronously retrieves states list
 *
 * @function
 * @returns {Promise<object[]>} array of state names.
 */
export const getStates = (queryParam) => {
    return axiosInstance
        .post(
            'api/Components/SearchBox',
            WrapImsPacket({ Key: 'STATES', Value: queryParam })
        )
        .then(response => {
            return then(response, payload => payload);
        })
        .catch(error => {
            throw error;
        });
}

/**
 * Asynchronously retrieves countries list
 *
 * @function
 * @returns {object[]} array of key-value-pairs of countries and abbreviations.
 */
export const getCountries = () => {
    return axiosInstance
        .get(
            `api/Components/Dropdown/COUNTRIES`
        )
        .then(response => {
            return then(response, payload => payload);
        })
        .catch(error => {
            throw error;
        });
}